"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTokenLocksForToken = exports.getAllTokenLocks = void 0;
const axios_1 = __importDefault(require("axios"));
const config_1 = require("../config");
const getAllTokenLocks = async () => {
    var _a, _b, _c, _d;
    const tokenLocks = [];
    let i = 0;
    do {
        try {
            const GET_ALL_TOKEN_LOCKS = `
        query getTokenLocks {
          hattokenLocks(first: 1000, skip: ${i * 1000}) {
            id
            factory {
              id
            }
            owner
            beneficiary
            token
            managedAmount
            startTime
            endTime
            periods
            releaseStartTime
            vestingCliffTime
            revocable
            canDelegate
            isAccepted
            isCanceled
            isRevoked
            releasedAmount
            hatData {
              balance
            }
          }
        }
      `;
            const subgraphsRequests = Object.values(config_1.ChainsConfig).map(async (chain) => {
                return {
                    chainId: chain.chain.id,
                    request: await axios_1.default.post(chain.subgraph, JSON.stringify({
                        query: GET_ALL_TOKEN_LOCKS,
                    }), {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }),
                };
            });
            const subgraphsResponses = await Promise.allSettled(subgraphsRequests);
            const fulfilledResponses = subgraphsResponses.filter((response) => response.status === "fulfilled");
            const subgraphsData = fulfilledResponses.map((res) => res.value);
            for (let i = 0; i < subgraphsData.length; i++) {
                const chainId = subgraphsData[i].chainId;
                if (!subgraphsData[i].request.data || !((_b = (_a = subgraphsData[i].request.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.hattokenLocks))
                    continue;
                for (const tokneLock of subgraphsData[i].request.data.data.hattokenLocks) {
                    tokenLocks.push({
                        chainId,
                        id: tokneLock.id,
                        factory: tokneLock.factory.id,
                        owner: tokneLock.owner,
                        beneficiary: tokneLock.beneficiary,
                        token: tokneLock.token,
                        managedAmount: tokneLock.managedAmount,
                        startTime: tokneLock.startTime,
                        endTime: tokneLock.endTime,
                        periods: tokneLock.periods,
                        releaseStartTime: tokneLock.releaseStartTime,
                        vestingCliffTime: tokneLock.vestingCliffTime,
                        revocable: tokneLock.revocable,
                        canDelegate: tokneLock.canDelegate,
                        isAccepted: tokneLock.isAccepted,
                        isCanceled: tokneLock.isCanceled,
                        isRevoked: tokneLock.isRevoked,
                        releasedAmount: tokneLock.releasedAmount,
                        hatBalance: (_d = (_c = tokneLock.hatData) === null || _c === void 0 ? void 0 : _c.balance) !== null && _d !== void 0 ? _d : 0
                    });
                }
            }
            i++;
        }
        catch (error) {
            return [];
        }
    } while (tokenLocks.length != 0 && tokenLocks.length % 1000 == 0);
    return tokenLocks;
};
exports.getAllTokenLocks = getAllTokenLocks;
const getTokenLocksForToken = async (tokenAddress, chainId) => {
    var _a, _b, _c;
    if (!tokenAddress || !chainId)
        return [];
    const tokenLocks = [];
    let i = 0;
    do {
        try {
            const GET_TOKEN_LOCKS_FOR_TOKEN = `
        query getTokenLocks($tokenAddress: Bytes) {
          hattokenLocks(where: {token: $tokenAddress}, first: 1000, skip: ${i * 1000}) {
            id
            factory {
              id
            }
            owner
            beneficiary
            token
            managedAmount
            startTime
            endTime
            periods
            releaseStartTime
            vestingCliffTime
            revocable
            canDelegate
            isAccepted
            isCanceled
            isRevoked
            releasedAmount
            hatData {
              balance
            }
          }
        }
      `;
            const subgraphResponse = axios_1.default.post(config_1.ChainsConfig[chainId].subgraph, JSON.stringify({
                query: GET_TOKEN_LOCKS_FOR_TOKEN,
                variables: { tokenAddress },
            }), {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            const subgraphData = (await subgraphResponse).data;
            if (!subgraphData.data || !((_a = subgraphData.data) === null || _a === void 0 ? void 0 : _a.hattokenLocks))
                return [];
            for (const tokneLock of subgraphData.data.hattokenLocks) {
                tokenLocks.push({
                    chainId,
                    id: tokneLock.id,
                    factory: tokneLock.factory.id,
                    owner: tokneLock.owner,
                    beneficiary: tokneLock.beneficiary,
                    token: tokneLock.token,
                    managedAmount: tokneLock.managedAmount,
                    startTime: tokneLock.startTime,
                    endTime: tokneLock.endTime,
                    periods: tokneLock.periods,
                    releaseStartTime: tokneLock.releaseStartTime,
                    vestingCliffTime: tokneLock.vestingCliffTime,
                    revocable: tokneLock.revocable,
                    canDelegate: tokneLock.canDelegate,
                    isAccepted: tokneLock.isAccepted,
                    isCanceled: tokneLock.isCanceled,
                    isRevoked: tokneLock.isRevoked,
                    releasedAmount: tokneLock.releasedAmount,
                    hatBalance: (_c = (_b = tokneLock.hatData) === null || _b === void 0 ? void 0 : _b.balance) !== null && _c !== void 0 ? _c : 0
                });
            }
            i++;
        }
        catch (error) {
            return [];
        }
    } while (tokenLocks.length != 0 && tokenLocks.length % 1000 == 0);
    return tokenLocks;
};
exports.getTokenLocksForToken = getTokenLocksForToken;
